import { api } from '@/core/api/';
import utils from '@/utils/utilities';

const messageBaseURL = 'api/message';
const calendarBaseURL = 'api/calendarEvent';

export default {
  async getDashboardAlerts(alertTypeId, pageIndex, pageSize) {
    const url = 'api/alert';
    return api.get(alertTypeId ? `${url}/${alertTypeId}` : url, {
      params: {
        pageIndex,
        pageSize,
      },
    });
  },
  async downloadDocumentByAttachmentId(attachmentId) {
    return api.get(`/api/documents/${attachmentId}`).then((response) => {
      utils.convertToBlob(response.data);
    });
  },
  async getDashboardMessages() {
    return await api.get('api/message/mesaggefordashboard');
  },
  async saveReadMessage(messageId) {
    return api.post(`api/message/savemessageread/${messageId}`);
  },
  searchMessages(filter) {
    return api.get(`${messageBaseURL}/search`, {
      params: filter,
    });
  },
  async fetchCategory() {
    return api.get(`${calendarBaseURL}/categories`);
  },
  async fetchRol() {
    return api.get(`${messageBaseURL}/roles`);
  },
  async fetchEventById(id) {
    return api.get(`${calendarBaseURL}/${id}`);
  },
  async deleteEvent(id) {
    return api.delete(`${calendarBaseURL}/delete/${id}`);
  },
  async updateEvent(data) {
    return api.put(`${calendarBaseURL}/edit`, data).catch((e) => {
      throw e.response.data.message;
    });
  },
  async saveEvent(data) {
    return api.post(`${calendarBaseURL}/save`, data).catch((e) => {
      throw e.response.data.message;
    });
  },
  async fetchEvents(categoryId, applicationId) {
    return api.get(
      `${calendarBaseURL}/events/0?categoryId=${categoryId}&applicationId=${applicationId}`
    );
  },
  async fetchSchedule(date) {
    return api.get(`${calendarBaseURL}/dailyevents`, {
      params: {
        date: date,
      },
    });
  },
};
